module.exports = __webpack_public_path__ + "img/guest-periodic.ae96eed1.svg";